import * as React from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import ResetPassword from "./resetPassword";
import "bootstrap/dist/css/bootstrap.min.css";

class ForgotPasswordPageComponent extends React.Component {
	state = {
		isValid: false, token: "", isFormSubmitted: false
	}
	constructor(props: any) {
		super(props);
		var tokenstr = (new URLSearchParams(window.location.search)).get("token");
		let tValue = tokenstr === null ? "" : tokenstr
		this.state = {
			isValid: false,
			token: tValue,
			isFormSubmitted: false
		}
	}
	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search)).get("token");
		let tValue = tokenstr === null ? "" : tokenstr
		this.setState({ token: tValue });
	}
	render() {
		return (
			<div className="App">
				<Container>
					<Row>
						<Col />
						<Col lg="8">
							<div className="jumbotron">
								<h2 className="center">
									Reset Password
								</h2>
								<Card>
									<CardBody>
										<ResetPassword tokenValue={this.state.token} />
									</CardBody>
								</Card>
							</div>
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default ForgotPasswordPageComponent